<script>
    import { navigate } from 'svelte-routing';
    import { store } from '../Store.svelte';
    import { env } from '../Environment.svelte';
    export let rightClick;
    export let rightClickText;

    let clickHandler = () => {
        if (window.location.pathname.includes('comparador')) {
            navigate(
                $store.requestedServices.isSky
                    ? env[env.stage].urlSkyWeb
                    : env[env.stage].urlIzziWeb
            );
        } else {
            navigate(
                $store.requestedServices.isSky
                    ? '/comparador/sky'
                    : '/comparador',
                { replace: false }
            );
            location.reload();
        }
    };
</script>

<header class="min">
    <div class="pure-g">
        <div class="pure-u-1">
            <div class="header-min-contents">
                <a
                    href="#/"
                    class="back-link"
                    on:click|preventDefault={clickHandler}
                    ><svg class="icon"
                        ><use
                            xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                        ></use></svg
                    > <span>Regresar al inicio</span></a
                >
                <div
                    on:click={clickHandler}
                    on:keydown={clickHandler}
                    class="header-logo"
                >
                    {#if $store.requestedServices.isSky}
                        <img
                            src="/assets/img/logos/sky-logo.svg"
                            alt="Sky logo"
                        />
                    {:else}
                        <img
                            src="/assets/img/logos/izzi-logo.svg"
                            alt="izzi logo"
                        />
                    {/if}
                </div>
                {#if rightClickText}
                    <a
                        href="#/"
                        class="back-link"
                        on:click|preventDefault={rightClick}
                        ><span>{rightClickText}</span></a
                    >
                {:else}
                    <div class="header-min-spacer"></div>
                {/if}
            </div>
        </div>
    </div>
</header>
